import { createSlice } from "@reduxjs/toolkit";

import { get, patch, post } from "../../helpers/axios";
import {
  GET_SURVEYS_LIST,
  POST_APPROVE_SURVEY,
  POST_CREATE_SURVEY,
  POST_REJECT_SURVEY,
} from "../../helpers/url_helpers";

const initialState = {
  loading: false,
  surveyListError: [],
  surveys: [],
  createSurveyLoading: false,
  newSurveyError: [],
  surveyEditable: false,
};

const surveyList = createSlice({
  name: "surveyList",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload.loading;
    },
    setSurveys: (state, action) => {
      state.surveys = action.payload.surveys;
    },
    setError: (state, action) => {
      state.surveyListError = action.payload.surveyListError;
    },
    setNewSurveyError: (state, action) => {
      state.newSurveyError = action.payload.newSurveyError;
    },
    setCreateSurveyLoading: (state, action) => {
      state.createSurveyLoading = action.payload;
    },
    reset: (state, action) => {
      if (action.payload?.isListWithSearch) state.surveys = [];
      state.loading = false;
      state.surveyListError = "";
      state.newSurveyError = "";
      state.createSurveyLoading = false;
      state.surveyEditable = false;
    },
    toggleSurveyEditable: (state, action) => {
      state.surveyEditable = !state.surveyEditable;
    },
  },
});

export const {
  setLoading,
  setSurveys,
  setError,
  setCreateSurveyLoading,
  setNewSurveyError,
  reset,
  toggleSurveyEditable,
} = surveyList.actions;
export default surveyList.reducer;

export const createSurvey = (payload, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setCreateSurveyLoading(true));
    dispatch(setNewSurveyError({ newSurveyError: "" }));

    // api call
    response = await post(POST_CREATE_SURVEY, payload);

    if (response) {
      dispatch(setCreateSurveyLoading(false));
      if (response.error) {
        dispatch(
          setNewSurveyError({
            newSurveyError: response?.error,
          })
        );
        if (callback) callback("failure");
      } else if (callback) callback("success");
    }
  } catch (error) {
    dispatch(setCreateSurveyLoading(false));
    if (error)
      dispatch(
        setNewSurveyError({
          newSurveyError: error,
        })
      );
  }
};

export const getSurveyList =
  (filterItem = "", searchItem = "") =>
  async (dispatch) => {
    let response;
    try {
      dispatch(setLoading({ loading: true }));
      dispatch(setError({ surveyListError: "" }));

      // api call
      response = await get(
        GET_SURVEYS_LIST.replace("{searchItem}", searchItem).replace(
          "{filterItem}",
          filterItem
        )
      );

      if (response) {
        if (response.error) {
          dispatch(
            setError({
              surveyListError: response?.error,
            })
          );
        } else {
          dispatch(
            setSurveys({
              surveys: response.data,
            })
          );
        }
      }

      dispatch(setLoading({ loading: false }));
    } catch (error) {
      if (error)
        dispatch(
          setError({
            surveyListError: error,
          })
        );
      dispatch(setLoading({ loading: false }));
    }
  };

export const clearError = () => async (dispatch) => {
  dispatch(setError({ surveyListError: "" }));
  dispatch(setNewSurveyError({ newSurveyError: [] }));
};
